import { Link } from "react-router-dom";
import type { Film } from "@/types";

interface FilmCardProps {
  film: Film;
}

export default function FilmCard({ film }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative h-56 w-full overflow-hidden bg-background-200">
        <img
          src={film.cover}
          alt={`${film.title}影视封面`}
          title={`${film.title} - 久久爱影视推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-900/80 px-2 py-0.5 text-xs font-medium text-background-50">
          {film.category}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-foreground-950">
          <i className="ri-star-fill text-[11px]"></i>
          {film.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3 md:p-4">
        <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">
          {film.title}
        </h3>
        <p className="mt-1 flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
          <span>{film.year}</span>
          <span className="text-background-300">·</span>
          <span className="truncate">{film.region}</span>
        </p>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {film.summary}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {film.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}